enum ConsortiaReportTypeEnum {
  DETAILED = 'consortiaDetailed',
  HIGH_LEVEL = 'consortiaHighLevel',
}

export default ConsortiaReportTypeEnum;
